module.exports = __webpack_public_path__ + "static/media/logoublick.9f181da8.png";